module.exports = __webpack_public_path__ + "static/media/blackSettingsIcon.03588179.svg";